<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Pregled evidence opravljenega dela</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                {{workHoursReports}}-->


                <b-form-group
                        label="Izberi obdobje in uporabnika"
                        label-for="month"
                >

                    <div class="row">
                        <div class="col-md-3">
                            <v-select
                                    v-model="month"
                                    placeholder="mesec"
                                    id="month"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 1, name: 'januar'},
                                {id: 2, name: 'februar'},
                                {id: 3, name: 'marec'},
                                {id: 4, name: 'april'},
                                {id: 5, name: 'maj'},
                                {id: 6, name: 'junij'},
                                {id: 7, name: 'julij'},
                                {id: 8, name: 'avgust'},
                                {id: 9, name: 'september'},
                                {id: 10, name: 'oktober'},
                                {id: 11, name: 'november'},
                                {id: 12, name: 'december'}
                            ]"
                                    @input="monthSelectionChanged">
                                >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-3">
                            <v-select
                                    v-model="year"
                                    placeholder="leto"
                                    id="year"
                                    name="year"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'},
                            ]"
                                    @input="yearSelectionChanged"
                            >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-3">
                            <v-select
                                    v-model="selectedUser"
                                    id="selectedUser"
                                    name="selectedUser"
                                    label="last_name"
                                    :options="users"
                                    :reduce="item => item.id"
                                    @input="userSelectionChanged"
                            >
                                <span slot="no-options">Ni zadetkov.</span>

                                <template slot="option" slot-scope="item">
                                    {{ getOptionLabel(item) }}
                                </template>

                                <template slot="selected-option" slot-scope="item">
                                    {{ getOptionLabel(item) }}
                                </template>


                            </v-select>
                        </div>
                        <div class="col-md-3">
                            <a class="btn btn-primary btn-sm text-white btn-block" @click="generatePdf"><i
                                    class="fas fa-file-pdf"></i> Prenesi poročilo</a>
                        </div>
                    </div>
                </b-form-group>

                <div class="row">
                    <div class="col-md-9">

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab title="Prikaz v tabeli"
                                       @click="$store.dispatch('setCurrentlySelectedViewMode', 'list')"
                                       :active="$store.getters.getCurrentlySelectedViewMode === 'list'">
                                    <vue-good-table
                                            styleClass="vgt-table table table-hover table-striped"
                                            :columns="columns"
                                            :rows="workHoursReports"
                                            :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                                            :sort-options="{
                                                        enabled: true,
                                                      }">

                                        <div slot="emptystate">
                                            <div class="text-center text-muted font-weight-light"><i
                                                    class="fa fa-exclamation-triangle"></i>
                                                <em>Ni podatkov.</em></div>
                                        </div>

                                        <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'date'">
                            {{moment.unix(props.row.date.seconds).format('DD. MM. YYYY')}}
                        </span>

                                            <span v-else-if="props.column.field == 'type'">
                            <div class="label" :class="props.row.type.split(' ').join('_')">{{props.row.type}}</div>
                        </span>

                                            <span v-else-if="props.column.field == 'duration'">
                            {{props.row.duration}}
                        </span>

                                            <span v-else-if="props.column.field == 'id'">

                            <router-link
                                    :to="{ name: 'AdminEditWorkHoursReport', params: {id: props.row.id, readonly: true }}"
                                    class="btn btn-info btn-sm text-white">
                                <i class="fa fa-eye"></i> Poglej</router-link>

                            <router-link :to="{ name: 'AdminEditWorkHoursReport', params: {id: props.row.id }}"
                                         class="btn btn-primary btn-sm text-white">
                                <i class="fa fa-edit"></i> Uredi</router-link>

                            <a class="btn btn-danger btn-sm text-white"
                               @click="deleteWorkHourReportConfirmation(props.row)"><i
                                    class="fa fa-trash"></i> Odstrani</a>
                        </span>

                                        </template>
                                    </vue-good-table>
                                </b-tab>
                                <b-tab title="Koledarski prikaz"
                                       @click="$store.dispatch('setCurrentlySelectedViewMode', 'calendar')"
                                       :active="$store.getters.getCurrentlySelectedViewMode === 'calendar'">

                                    <FullCalendar
                                            ref="fullCalendar"
                                            defaultView="dayGridMonth"
                                            :plugins="calendarPlugins"
                                            :weekends="true"
                                            :first-day="1"
                                            :events="events"
                                            :default-date="defaultDate"
                                            :locale="'sl'"
                                            :lang="'sl'"
                                            :height="'auto'"
                                            @dateClick="handleCalendarDateClick"
                                            @eventClick="handleEventClick"
                                            @datesRender="handleCalendarDatesRender"
                                            @dayRender="handleCalendarDayRender"

                                    />
                                </b-tab>
                            </b-tabs>
                        </div>

                      <div class="row">
                        <div class="col-md-12 mt-3 mb-5">

                          <router-link :to="{ name: 'AdminEditWorkHoursReport' }" class="btn btn-success">
                            <i class="fa fa-plus"></i> Dodaj zapis v evidenco
                          </router-link>

                        </div>
                      </div>


                    </div>
                    <div class="col-md-3">
                        <div class="alert alert-info">
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Redno delo</dt>
                                <dd class="col-sm-4">{{workHoursTotal}}</dd>

                                <dt class="col-sm-8">Praznik</dt>
                                <dd class="col-sm-4">{{holidaysTotal}}</dd>

                                <dt class="col-sm-8">Letni dopust</dt>
                                <dd class="col-sm-4">{{vacationsTotal}}</dd>

                                <dt class="col-sm-8">Bolniški dopust</dt>
                                <dd class="col-sm-4">{{sickLeaveTotal}}</dd>

                                <dt class="col-sm-8 mb-0">Neplačan dopust</dt>
                                <dd class="col-sm-4 mb-0">{{unpaidLeaveTotal}}</dd>
                            </dl>
                        </div>

                        <div class="alert alert-warning mt-3">
                            <h5>Stanje nadur za leto {{year}}</h5>
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Zabeležene nadure</dt>
                                <dd class="col-sm-4">{{overtimeEarnedTotal}}</dd>

                                <dt class="col-sm-8">Koriščene nadure</dt>
                                <dd class="col-sm-4">{{overtimeUsedTotal}}</dd>

                                <dt class="col-sm-8 mb-0">Trenutno stanje nadur</dt>
                                <dd class="col-sm-4 mb-0">{{overtimeBalance}}</dd>
                            </dl>
                            <div class="small text-muted mt-2">
                                Stanje nadur se ponastavlja vsako leto (1. januarja).
                            </div>
                        </div>

                        <div class="alert alert-success mt-3">
                            <h5>Stanje dopusta za leto {{year}}</h5>
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Skupno dni dopusta</dt>
                                <dd class="col-sm-4">{{vacationDaysTotal}}</dd>

                                <dt class="col-sm-8">Koriščeni dnevi</dt>
                                <dd class="col-sm-4">{{vacationDaysUsed}}</dd>

                                <dt class="col-sm-8 mb-0">Preostali dnevi</dt>
                                <dd class="col-sm-4 mb-0">{{vacationDaysRemaining}}</dd>
                            </dl>
                        </div>
                    </div>
                </div>


            </div>
        </div>



    </div>

</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {add} from 'timelite/time'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction'

  export default {
    name: 'WorkHoursReport',
    components: {
      VueGoodTable,
      Loading,
      vSelect,
      FullCalendar
    },
    data () {
      return {
        isLoading: false,
        month: parseInt(this.$store.getters.getCurrentlySelectedMonth) + 1,
        year: parseInt(this.$store.getters.getCurrentlySelectedYear),
        defaultDate: this.moment().set({
          year: this.$store.getters.getCurrentlySelectedYear,
          month: this.$store.getters.getCurrentlySelectedMonth
        }).format('YYYY-MM-DD'),
        selectedUser: this.$store.getters.getCurrentlySelectedUser,
        users: this.$store.getters.getUsers,
        currentlySelectedViewMode: this.$store.getters.getCurrentlySelectedViewMode,
        workHoursReports: [],
        yearlyOvertimeReports: [],
        yearlyVacationReports: [],
        allYearlyReports: [],
        events: [],
        calendarPlugins: [dayGridPlugin, interactionPlugin],
        columns: [
          {
            label: 'Datum',
            field: 'date',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Tip dela',
            field: 'type',
            type: 'text',
            sortable: true,
          },
          {
            label: 'število ur',
            field: 'duration',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '350px'
          }
        ],
        workHoursTotal: '0:0',
        holidaysTotal: '0:0',
        vacationsTotal: '0:0',
        sickLeaveTotal: '0:0',
        unpaidLeaveTotal: '0:0',
        overtimeEarnedTotal: '0:0',
        overtimeUsedTotal: '0:0',
        overtimeBalance: '0:0',
        overtimeBalanceHistory: [],
        vacationDaysTotal: 0,  // No default value, will be loaded from Firestore
        vacationDaysUsed: 0,
        vacationDaysRemaining: 0,
        vacationBalance: {}
      }
    },
    mounted () {
      const _this = this;

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers;
          
          // After loading users, ensure the selectedUser is set from the store
          _this.selectedUser = _this.$store.getters.getCurrentlySelectedUser;
          
          // Also set filterSelectedUser for consistency
          _this.$store.dispatch('setFilterSelectedUser', _this.selectedUser);
          
          // Now initialize all reports and data
          _this.retrieveWorkHoursReports(true);
          _this.retrieveOvertimeBalanceHistory();
          _this.retrieveVacationAllowance();
        })
      } else {
        // If users are already loaded, make sure selectedUser is in sync with store
        _this.selectedUser = _this.$store.getters.getCurrentlySelectedUser;
        
        // Also set filterSelectedUser for consistency
        _this.$store.dispatch('setFilterSelectedUser', _this.selectedUser);
        
        // Now initialize all reports and data
        _this.retrieveWorkHoursReports(true);
        _this.retrieveOvertimeBalanceHistory();
        _this.retrieveVacationAllowance();
      }
    },
    methods: {

      generatePdf () {
        const _this = this;

        // Create PDF with UTF-8 support
        let doc = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        // Helper function to replace Slovenian characters with ASCII equivalents
        // since jsPDF doesn't handle them well
        function normalizeText(text) {
          // Ensure the text is a string
          if (typeof text !== 'string') {
            return String(text);
          }

          // Replace Slovenian characters with their ASCII equivalents
          return text
            .replace(/č/g, 'c').replace(/Č/g, 'C')
            .replace(/ć/g, 'c').replace(/Ć/g, 'C')
            .replace(/ž/g, 'z').replace(/Ž/g, 'Z')
            .replace(/š/g, 's').replace(/Š/g, 'S')
            .replace(/đ/g, 'd').replace(/Đ/g, 'D');
        }

        let body = [];
        let userId = '';
        let month = _this.moment.months(_this.month - 1);

        _this.workHoursReports.forEach(function (report, i) {
          userId = report.userId;

          // For the work type, we need to manually replace problematic entries
          let workType = report.type;
          if (workType === 'beleženje nadur') workType = 'belezenje nadur';
          if (workType === 'koriščenje nadur') workType = 'koriscenje nadur';
          if (workType === 'bolniški dopust') workType = 'bolniski dopust';
          if (workType === 'neplačan dopust') workType = 'neplacan dopust';

          body.push([
            i + 1,
            _this.moment.unix(report.date.seconds).format('DD. MM. YYYY'),
            normalizeText(_this.getReadableUser(report.userId)),
            workType,
            report.duration
          ]);
        });

        // Title
        const title = month.charAt(0).toUpperCase() + month.slice(1) + ' ' + _this.year + ':\nEvidenca ur za osebo ' + normalizeText(_this.getReadableUser(userId));

        doc.autoTable({
          theme: 'plain',
          tableWidth: 'wrap',
          margin: {top: 15},
          head: [[title]],
          body: [],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 12, fillColor: [255, 255, 255], textColor: [0, 0, 0] }
        });

        // Create three tables side by side in one row
        // First, calculate positions for each table
        const pageWidth = doc.internal.pageSize.getWidth();
        const tableWidth = pageWidth / 3 - 10; // Divide page into 3 columns with some margin
        
        // Regular hours - First table (left)
        doc.autoTable({
          startY: 30,
          margin: {left: 10},
          tableWidth: tableWidth,
          head: [['Tip', 'Ure (H:M)']],
          body: [
            ['Redno delo', _this.workHoursTotal],
            ['Prazniki', _this.holidaysTotal],
            ['Letni dopust', _this.vacationsTotal],
            ['Bolniski dopust', _this.sickLeaveTotal],
            ['Neplacan dopust', _this.unpaidLeaveTotal]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [240, 240, 240], textColor: [0, 0, 0] }
        });
        
        // Overtime - Second table (middle)
        const leftTableHeight = doc.previousAutoTable.finalY;
        doc.autoTable({
          startY: 30,
          margin: {left: tableWidth + 15}, // Position after first table
          tableWidth: tableWidth,
          head: [['Nadure za leto ' + _this.year, 'Ure (H:M)']],
          body: [
            ['Zabelezene nadure', _this.overtimeEarnedTotal],
            ['Koriscene nadure', _this.overtimeUsedTotal],
            ['Stanje nadur', _this.overtimeBalance]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [255, 236, 184], textColor: [0, 0, 0] }
        });
        
        // Vacation days - Third table (right)
        doc.autoTable({
          startY: 30,
          margin: {left: (tableWidth * 2) + 20}, // Position after second table
          tableWidth: tableWidth,
          head: [['Dopust za leto ' + _this.year, 'Dnevi']],
          body: [
            ['Skupno dni dopusta', _this.vacationDaysTotal],
            ['Korisceni dnevi', _this.vacationDaysUsed],
            ['Preostali dnevi', _this.vacationDaysRemaining]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [198, 239, 206], textColor: [0, 0, 0] }
        });
        
        // Get the tallest table height to know where to start the next section
        const highestY = Math.max(
          doc.previousAutoTable.finalY,
          leftTableHeight || 0
        );

        // Detailed report - start after the summary tables with a margin
        doc.autoTable({
          startY: highestY + 20, // Start after the summary tables
          margin: {left: 10, right: 10},
          head: [['#', 'Datum', 'Oseba', 'Tip', 'St. ur']],
          body: body,
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [220, 220, 220], textColor: [0, 0, 0] }
        });

        // Save with normalized filename (remove special characters from filename)
        const normalizedName = normalizeText(_this.getReadableUser(userId)).replace(/\s+/g, '_');
        doc.save(_this.year + '_' + _this.month + '_mesecno_porocilo_' + normalizedName + '.pdf');
      },
      // retrieveWorkHoursReports () {
      //   const _this = this
      //
      //   console.log('-----------> retrieveWorkHoursReports')
      //
      //   console.log('-----------> this.$store.getters.getCurrentlySelectedMonth', this.$store.getters.getCurrentlySelectedMonth);
      //
      //   let workHourReports = db.collection('workHoursReports')
      //
      //   let startDate = _this.moment().set({
      //     date: 1,
      //     month: _this.$store.getters.getCurrentlySelectedMonth,
      //     year: _this.$store.getters.getCurrentlySelectedYear
      //   }).startOf('month')
      //   let endDate = _this.moment(startDate).endOf('month')
      //
      //   _this.defaultDate = _this.moment(startDate).format('YYYY-MM-DD')
      //
      //   let calendarApi = _this.$refs.fullCalendar.getApi()
      //   calendarApi.gotoDate(_this.moment(startDate).format('YYYY-MM-DD'))
      //
      //   //calendarApi('goToDate', startDate);
      //
      //   console.log('startDate', startDate)
      //   console.log('endDate', endDate)
      //
      //   workHourReports
      //     .where('date', '>=', _this.moment(startDate).toDate())
      //     .where('date', '<=', _this.moment(endDate).toDate())
      //     .get()
      //     .then(querySnapshot => {
      //       _this.workHoursReports = _.filter(querySnapshot.docs.map(doc => doc.data()), {'userId': _this.$store.getters.getCurrentlySelectedUser})
      //
      //       console.log('RESULTS:', _this.workHoursReports)
      //
      //       _this.events = []
      //
      //       _.each(_this.workHoursReports, function (report) {
      //         console.log('report', report)
      //         let reportItem = {
      //           className: report.type.split(' ').join('_'),
      //           title: report.type,
      //           date: _this.moment.unix(report.date.seconds).format('YYYY-MM-DD'),
      //           data: report
      //         }
      //
      //         _this.events.push(reportItem)
      //       })
      //
      //       _this.calculateTotals()
      //       _this.isLoading = false
      //     })
      //     .catch(function (error) {
      //       // The document probably doesn't exist.
      //       console.log('Error getting documents: ', error)
      //       _this.isLoading = false
      //     })
      //
      // },

      // Handlers for the various filters
      monthSelectionChanged(monthId) {
        const _this = this;
        console.log('Month changed to:', monthId);
        
        // Convert from 1-based month (UI) to 0-based month (JavaScript)
        _this.$store.dispatch('setCurrentlySelectedMonth', (monthId - 1));
        
        // Keep the currently selected user
        _this.retrieveWorkHoursReports(true);
      },
      
      yearSelectionChanged(yearId) {
        const _this = this;
        console.log('Year changed to:', yearId);
        
        _this.$store.dispatch('setCurrentlySelectedYear', yearId);
        
        // Keep the currently selected user
        _this.retrieveWorkHoursReports(true);
      },
      
      userSelectionChanged(userId) {
        const _this = this;
        console.log('User changed to:', userId);
        
        // Dispatch both currentlySelectedUser and filterSelectedUser to ensure consistency
        _this.$store.dispatch('setCurrentlySelectedUser', userId);
        _this.$store.dispatch('setFilterSelectedUser', userId);
        
        // Explicitly retrieve vacation information for the new user
        _this.retrieveVacationAllowance();
        
        // Also reload overtime balance history for the newly selected user
        _this.retrieveOvertimeBalanceHistory();
        
        // Now retrieve the reports with the new user
        _this.retrieveWorkHoursReports(true);
      },
      
      retrieveWorkHoursReports(keepUserSelection = false) {
        const _this = this;

        _this.isLoading = true;
        
        // Get the currently selected user from store or local variable depending on keepUserSelection flag
        const selectedUserId = keepUserSelection ? 
          _this.selectedUser : _this.$store.getters.getCurrentlySelectedUser;
        
        console.log('Retrieving reports with user selection preserved:', keepUserSelection);
        console.log('Using user ID:', selectedUserId);
        console.log('Local selectedUser:', _this.selectedUser);
        console.log('Store user:', _this.$store.getters.getCurrentlySelectedUser);
        console.log('Selected month (1-based):', _this.month);
        console.log('Store month (0-based):', _this.$store.getters.getCurrentlySelectedMonth);
        
        // Keep the user selection if specified, otherwise sync with store
        if (!keepUserSelection && _this.selectedUser !== selectedUserId) {
          _this.selectedUser = selectedUserId;
        } else if (keepUserSelection && _this.selectedUser !== _this.$store.getters.getCurrentlySelectedUser) {
          // If we want to keep the selection but it's different from store, update the store
          _this.$store.dispatch('setCurrentlySelectedUser', _this.selectedUser);
          _this.$store.dispatch('setFilterSelectedUser', _this.selectedUser);
        }

        // For calendar and monthly view - using the component's month and year values directly
        // This fixes the issue where the Firestore query doesn't match the UI selection
        let startDate = _this.moment().set({
          date: 1,
          month: _this.month - 1, // Convert from 1-based to 0-based month
          year: _this.year
        }).startOf('month');
        
        let endDate = _this.moment(startDate).endOf('month');

        // Update store to match our current UI state
        _this.$store.dispatch('setCurrentlySelectedMonth', _this.month - 1);
        _this.$store.dispatch('setCurrentlySelectedYear', _this.year);

        // For overtime calculation, we need the full year's data
        let yearStartDate = _this.moment().set({
          date: 1,
          month: 0, // January
          year: _this.year
        }).startOf('month');
        
        let yearEndDate = _this.moment().set({
          date: 31,
          month: 11, // December
          year: _this.year
        }).endOf('month');

        _this.defaultDate = _this.moment(startDate).format('YYYY-MM-DD');

        if (_this.$refs.fullCalendar) {
          let calendarApi = _this.$refs.fullCalendar.getApi();
          calendarApi.gotoDate(_this.moment(startDate).format('YYYY-MM-DD'));
        }

        console.log('Start date for query:', startDate.format('YYYY-MM-DD'));
        console.log('End date for query:', endDate.format('YYYY-MM-DD'));

        // First, get the monthly data for display
        let workHourReports = db.collection('workHoursReports');
        
        // Clear existing data
        _this.workHoursReports = [];
        _this.events = [];
        
        // First do a full year query to get ALL data we need for calculations
        // This ensures vacation days and overtime are calculated using the full year data
        workHourReports
          .where('date', '>=', _this.moment(yearStartDate).toDate())
          .where('date', '<=', _this.moment(yearEndDate).toDate())
          .get()
          .then(yearlyQuerySnapshot => {
            console.log('Yearly query returned', yearlyQuerySnapshot.docs.length, 'documents before filtering');
            
            // Convert all documents to data and filter by user ID
            const allYearlyReports = yearlyQuerySnapshot.docs
              .map(doc => doc.data())
              .filter(report => report.userId === selectedUserId);
            
            console.log('All yearly reports for this user:', allYearlyReports.length);
            
            // Store all yearly data for full calculations
            _this.allYearlyReports = allYearlyReports;
            
            // Get just the reports for the selected month for display
            const monthlyReports = allYearlyReports.filter(report => {
              const reportDate = _this.moment.unix(report.date.seconds);
              return reportDate.month() === (startDate.month()) && 
                     reportDate.year() === startDate.year();
            });
            
            console.log('Filtered for selected month:', monthlyReports.length, 'reports');
            
            // Set the monthly reports for display in the table
            _this.workHoursReports = monthlyReports;
            
            // Create calendar events
            _.each(monthlyReports, function (report) {
              const reportDate = _this.moment.unix(report.date.seconds);
              
              let reportItem = {
                className: report.type.split(' ').join('_'),
                title: report.type,
                date: reportDate.format('YYYY-MM-DD'),
                data: report
              };

              _this.events.push(reportItem);
            });
            
            // Extract overtime data
            const overtimeReports = allYearlyReports.filter(report => 
              report.type === 'beleženje nadur' || report.type === 'koriščenje nadur'
            );
            
            console.log('Overtime reports for the year:', overtimeReports.length);
            _this.yearlyOvertimeReports = overtimeReports;
            
            // Extract vacation data
            const vacationReports = allYearlyReports.filter(report => 
              report.type === 'letni dopust'
            );
            
            console.log('Vacation reports for the year:', vacationReports.length);
            _this.yearlyVacationReports = vacationReports;
            
            // Calculate totals using the monthly data for display totals
            // and the yearly data for yearly calculations
            _this.calculateTotals();
            
            // Make sure to get the vacation allowance for the currently selected user
            _this.retrieveVacationAllowance();
            
            // Also get overtime balance history
            _this.retrieveOvertimeBalanceHistory();
            
            _this.isLoading = false;
          })
          .catch(function (error) {
            console.error('Error getting yearly documents: ', error);
            // Show user-friendly error notification
            _this.$swal({
              title: 'Napaka pri pridobivanju podatkov',
              text: 'Prišlo je do napake pri pridobivanju podatkov. Poskusite znova ali kontaktirajte administratorja.',
              icon: 'error',
              button: 'V redu',
            });
            _this.isLoading = false;
          });
      },


      calculateTotals () {
        const _this = this;

        // Reset all counters
        _this.workHoursTotal = '0:0';
        _this.holidaysTotal = '0:0';
        _this.vacationsTotal = '0:0';
        _this.sickLeaveTotal = '0:0';
        _this.unpaidLeaveTotal = '0:0';
        _this.overtimeEarnedTotal = '0:0';
        _this.overtimeUsedTotal = '0:0';
        _this.vacationDaysUsed = 0;

        // Calculate regular totals from reports in the selected month (already filtered in workHoursReports)
        console.log('Calculating monthly totals from', _this.workHoursReports.length, 'reports');
        
        _.each(_this.workHoursReports, function (val, key) {
          // Log each report to verify it's in the correct month
          const reportDate = _this.moment.unix(val.date.seconds);
          console.log('Report in totals:', reportDate.format('YYYY-MM-DD'), val.type, val.duration);
          
          if (val.type === 'redno delo' || val.type === 'izobraževanje' || val.type === 'drugo') {
            _this.workHoursTotal = add([_this.workHoursTotal, val.duration])[0] + ':' + add([_this.workHoursTotal, val.duration])[1];
          } else if (val.type === 'letni dopust') {
            _this.vacationsTotal = add([_this.vacationsTotal, val.duration])[0] + ':' + add([_this.vacationsTotal, val.duration])[1];
          } else if (val.type === 'praznik') {
            _this.holidaysTotal = add([_this.holidaysTotal, val.duration])[0] + ':' + add([_this.holidaysTotal, val.duration])[1];
          } else if (val.type === 'bolniški dopust') {
            _this.sickLeaveTotal = add([_this.sickLeaveTotal, val.duration])[0] + ':' + add([_this.sickLeaveTotal, val.duration])[1];
          } else if (val.type === 'neplačan dopust') {
            _this.unpaidLeaveTotal = add([_this.unpaidLeaveTotal, val.duration])[0] + ':' + add([_this.unpaidLeaveTotal, val.duration])[1];
          }
        });

        // Calculate yearly overtime totals from the yearlyOvertimeReports array
        if (_this.yearlyOvertimeReports && _this.yearlyOvertimeReports.length > 0) {
          console.log('Calculating yearly overtime from', _this.yearlyOvertimeReports.length, 'reports');
          
          // Calculate overtime totals from yearly data
          _.each(_this.yearlyOvertimeReports, function (val) {
            const reportDate = _this.moment.unix(val.date.seconds);
            console.log('Overtime entry:', reportDate.format('YYYY-MM-DD'), val.type, val.duration);
            
            if (val.type === 'beleženje nadur') {
              _this.overtimeEarnedTotal = add([_this.overtimeEarnedTotal, val.duration])[0] + ':' + add([_this.overtimeEarnedTotal, val.duration])[1];
            } else if (val.type === 'koriščenje nadur') {
              _this.overtimeUsedTotal = add([_this.overtimeUsedTotal, val.duration])[0] + ':' + add([_this.overtimeUsedTotal, val.duration])[1];
            }
          });
        }
        
        // Calculate vacation days used for the entire year
        if (_this.yearlyVacationReports && _this.yearlyVacationReports.length > 0) {
          console.log('Calculating yearly vacation days from', _this.yearlyVacationReports.length, 'entries');
          
          _.each(_this.yearlyVacationReports, function (val) {
            // 8 hours is a full workday
            if (val.duration === '8:0' || val.duration === '8:00') {
              _this.vacationDaysUsed += 1;
            } else {
              // For partial days, convert to fractional days (e.g., 4 hours = 0.5 days)
              const durationParts = val.duration.split(':');
              const hours = parseInt(durationParts[0]);
              const minutes = parseInt(durationParts[1]);
              const totalHours = hours + (minutes / 60);
              _this.vacationDaysUsed += (totalHours / 8); // Assuming 8-hour workday
            }
          });
        }

        // Round vacationDaysUsed to nearest 0.5
        _this.vacationDaysUsed = Math.round(_this.vacationDaysUsed * 2) / 2;

        // Calculate remaining vacation days
        _this.vacationDaysRemaining = _this.vacationDaysTotal - _this.vacationDaysUsed;
        _this.vacationDaysRemaining = Math.max(0, _this.vacationDaysRemaining); // Ensure it's never negative

        // Calculate overtime balance for current year only
        const earnedParts = _this.overtimeEarnedTotal.split(':');
        const usedParts = _this.overtimeUsedTotal.split(':');

        const earnedMinutes = parseInt(earnedParts[0]) * 60 + parseInt(earnedParts[1]);
        const usedMinutes = parseInt(usedParts[0]) * 60 + parseInt(usedParts[1]);

        const balanceMinutes = earnedMinutes - usedMinutes;
        const balanceHours = Math.floor(Math.abs(balanceMinutes) / 60);
        const balanceRemainingMinutes = Math.abs(balanceMinutes) % 60;

        if (balanceMinutes >= 0) {
          _this.overtimeBalance = balanceHours + ':' + (balanceRemainingMinutes < 10 ? '0' + balanceRemainingMinutes : balanceRemainingMinutes);
        } else {
          _this.overtimeBalance = '-' + balanceHours + ':' + (balanceRemainingMinutes < 10 ? '0' + balanceRemainingMinutes : balanceRemainingMinutes);
        }

        _this.updateOvertimeBalance();
        _this.updateVacationBalance();
      },

      updateOvertimeBalance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;

        // Get current year's balance
        db.collection('overtimeBalance')
          .where('userId', '==', userId)
          .where('year', '==', _this.year)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.empty) {
              // Create new balance record if it doesn't exist
              let newBalanceRef = db.collection('overtimeBalance').doc();
              newBalanceRef.set({
                id: newBalanceRef.id,
                userId: userId,
                year: _this.year,
                balance: _this.overtimeBalance,
                lastUpdated: new Date()
              });
            } else {
              // Update existing balance
              const balanceDoc = querySnapshot.docs[0];
              balanceDoc.ref.update({
                balance: _this.overtimeBalance,
                lastUpdated: new Date()
              });
            }
          })
          .catch(error => {
            console.error('Error updating overtime balance:', error);
          });
      },

      getOptionLabel (option) {
        //console.log(option);
        return this.getReadableUser(option.id)
      },

      handleCalendarDateClick (info) {
        const _this = this
        console.log(info)
        console.log('handleCalendarDateClick')

        _this.$router.push({name: 'AdminEditWorkHoursReport', params: {date: info.date}})
      },

      handleEventClick (info) {
        const _this = this
        console.log('handleEventClick', info)
        let eventId = info.event._def.extendedProps.data.id

        _this.$router.push({name: 'AdminEditWorkHoursReport', params: {id: eventId}})
      },

      handleCalendarDatesRender (info) {
        const _this = this;
        console.log('Calendar dates rendered, info:', info);

        // Get the currently selected month from the calendar
        let calendarApi = _this.$refs.fullCalendar.getApi();
        const calendarMonth = parseInt(_this.moment(calendarApi.getDate()).format('MM'));
        const calendarMonthZeroBased = calendarMonth - 1; // Convert to 0-based
        const calendarYear = parseInt(_this.moment(calendarApi.getDate()).format('YYYY'));
        
        console.log('Calendar date:', _this.moment(calendarApi.getDate()).format('YYYY-MM-DD'));
        console.log('Calendar month (1-based):', calendarMonth);
        console.log('Current selected month (1-based):', _this.month);
        
        // Only update if the calendar month differs from the current UI selection
        if (calendarMonth !== _this.month || calendarYear !== _this.year) {
          console.log('Calendar navigation changed month/year, updating dropdowns');
          
          // Update store without affecting the selected user
          _this.$store.dispatch('setCurrentlySelectedMonth', calendarMonthZeroBased);
          _this.$store.dispatch('setCurrentlySelectedYear', calendarYear);
          
          // Update local variables to match calendar
          _this.month = calendarMonth;
          _this.year = calendarYear;
          
          // Get reports with current filter settings, keeping the user selection
          _this.retrieveWorkHoursReports(true);
        }
      },

      handleCalendarDayRender (info) {
        //console.log("handleCalendarDayRender", info);
      },

      deleteWorkHourReportConfirmation (data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati evidenco za dan ' + _this.moment.unix(data.date.seconds).format('DD. MM. YYYY') + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHourReport(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHourReport (id) {
        const _this = this
        _this.isLoading = true
        db.collection('workHoursReports').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.retrieveWorkHoursReports()
            //_this.$router.push({name: 'AdminWorkHoursReport'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      },
      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },
      setMonthFilter () {
        const _this = this
        _this.month = _this.month
        console.log(_this.month)
      },
      setYearFilter () {
        console.log(_this.year)
      },

      updateOvertimeBalance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;
        const currentYear = _this.year;

        // Make sure we're using the specific year
        db.collection('overtimeBalance')
          .where('userId', '==', userId)
          .where('year', '==', currentYear)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.empty) {
              // Create new balance record if it doesn't exist
              let newBalanceRef = db.collection('overtimeBalance').doc();
              newBalanceRef.set({
                id: newBalanceRef.id,
                userId: userId,
                year: currentYear,
                balance: _this.overtimeBalance,
                earnedTotal: _this.overtimeEarnedTotal,
                usedTotal: _this.overtimeUsedTotal,
                lastUpdated: new Date()
              })
              .catch(error => {
                console.error('Error creating overtime balance:', error);
                // Don't show error to user as this is a background operation
              });
            } else {
              // Update existing balance
              const balanceDoc = querySnapshot.docs[0];
              balanceDoc.ref.update({
                balance: _this.overtimeBalance,
                earnedTotal: _this.overtimeEarnedTotal,
                usedTotal: _this.overtimeUsedTotal,
                lastUpdated: new Date()
              })
              .catch(error => {
                console.error('Error updating overtime record:', error);
                // Don't show error to user as this is a background operation
              });
            }
          })
          .catch(error => {
            console.error('Error updating overtime balance:', error);
          });
      },

      retrieveOvertimeBalanceHistory() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;

        // Simplified query that doesn't require a composite index
        db.collection('overtimeBalance')
          .where('userId', '==', userId)
          .get()
          .then(querySnapshot => {
            // Get all records and sort them in JavaScript
            _this.overtimeBalanceHistory = querySnapshot.docs
              .map(doc => doc.data())
              .sort((a, b) => b.year - a.year); // Sort by year descending

            // Check if we have a record for the current year
            const hasCurrentYearRecord = _this.overtimeBalanceHistory.some(record =>
              record.year === _this.year
            );

            // If we don't have a record for the current year, create one
            if (!hasCurrentYearRecord && _this.overtimeBalance) {
              _this.updateOvertimeBalance();
            }

            console.log('Overtime balance history by year:', _this.overtimeBalanceHistory);
          })
          .catch(error => {
            console.error('Error retrieving overtime balance history:', error);
            // Silent error - don't show to user as this is a background operation
          });
      },

      retrieveVacationAllowance() {
        const _this = this;
        
        // Always get the most current user ID from the store
        const userId = _this.$store.getters.getCurrentlySelectedUser;
        
        console.log('Retrieving vacation allowance for user:', userId, 'and year:', _this.year);
        console.log('Local selectedUser:', _this.selectedUser);
        console.log('Store user:', _this.$store.getters.getCurrentlySelectedUser);

        // First check if we have vacation days settings in the vacationDaysReports collection
        // This is the collection used by the "Pregled evidence dopusta" page
        db.collection('vacationDaysReports')
          .where('userId', '==', userId)
          .where('year', '==', _this.year)
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              // Found existing vacation days report
              const vacationData = querySnapshot.docs[0].data();
              console.log('Found vacation days report:', vacationData);
              
              // Use the daysTotal from the report WITHOUT any default fallback
              // This ensures we use exactly what was set in the admin interface
              _this.vacationDaysTotal = vacationData.daysTotal;
              _this.vacationBalance = vacationData;

              console.log('Set vacation days total exactly to:', _this.vacationDaysTotal);
              
              // Recalculate remaining days
              _this.vacationDaysRemaining = _this.vacationDaysTotal - _this.vacationDaysUsed;
              console.log('Vacation days used:', _this.vacationDaysUsed);
              console.log('Vacation days remaining:', _this.vacationDaysRemaining);
            } else {
              console.log('No vacation days report found, no vacation days allocated');
              // No vacation days report set for this year, set to 0 (no allocation)
              _this.vacationDaysTotal = 0; // No default value
              _this.vacationDaysRemaining = 0;
              
              // We don't create a record automatically here as that should be done by an admin
            }
          })
          .catch(error => {
            console.error('Error retrieving vacation days report:', error);
            // Show user-friendly error notification - this is important for user experience
            _this.$swal({
              title: 'Napaka pri pridobivanju podatkov o dopustu',
              text: 'Prišlo je do napake pri pridobivanju podatkov o dopustu. Podatki o dopustu morda ne bodo pravilni.',
              icon: 'warning',
              button: 'V redu',
            });
          });
      },

      updateVacationBalance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;
        
        console.log('Updating vacation usage statistics (not the total days)');
        console.log('Used days:', _this.vacationDaysUsed);
        console.log('Remaining days:', _this.vacationDaysRemaining);

        // We'll only update the usage statistics (used days and remaining days)
        // We won't create records or update the total days - that's the admin's job in the VacationDaysReport page
        
        // Find existing vacation reports for this user and year
        db.collection('vacationDaysReports')
          .where('userId', '==', userId)
          .where('year', '==', _this.year)
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              // Only update existing records with usage stats
              const vacationDoc = querySnapshot.docs[0];
              
              // Store the usage statistics in a separate collection
              // This is just for tracking - not for changing the total days
              let usageRef = db.collection('vacationUsageStats').doc();
              usageRef.set({
                id: usageRef.id,
                vacationReportId: vacationDoc.id,
                userId: userId,
                year: _this.year,
                usedDays: _this.vacationDaysUsed,
                remainingDays: _this.vacationDaysRemaining,
                totalDays: _this.vacationDaysTotal, // Reference only - not for updating the total
                lastUpdated: new Date()
              })
              .catch(error => {
                console.error('Error storing vacation usage stats:', error);
              });
            }
          })
          .catch(error => {
            console.error('Error updating vacation usage stats:', error);
          });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/WorkHoursReport.vue